<template>
  <path
    d="M19 3.00024H5C3.89 3.00024 3 3.90024 3 5.00024V19.0002C3 20.1002 3.89 21.0002 5 21.0002H19C20.1 21.0002 21 20.1002 21 19.0002V5.00024C21 3.90024 20.11 3.00024 19 3.00024ZM19 19.0002H5V7.00024H19V19.0002ZM16 12.0002H8C7.45 12.0002 7 11.5502 7 11.0002C7 10.4502 7.45 10.0002 8 10.0002H16C16.55 10.0002 17 10.4502 17 11.0002C17 11.5502 16.55 12.0002 16 12.0002ZM12 16.0002H8C7.45 16.0002 7 15.5502 7 15.0002C7 14.4502 7.45 14.0002 8 14.0002H12C12.55 14.0002 13 14.4502 13 15.0002C13 15.5502 12.55 16.0002 12 16.0002Z"
  />
</template>
